/** @file Guard: the second bone of a two-bone IK keeps inherit "normal" (setup and keys alike). */
import type { Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';

/** IK_INVALID at `value` when `boneId` is the child of a two-bone IK and `inherit` is not "normal"; `ref` names it in the hint. */
export function assertIkChildInherit(doc: Doc, boneId: Id, inherit: unknown, ref: string): void {
  if (inherit === 'normal') return;
  const ik = Object.values(doc.constraints).find((c) => c.bones.at(1) === boneId);
  if (ik) throwError('IK_INVALID', { ik: ik.name, reason: 'the child bone must use inherit "normal"' }, { path: 'value', hint: `IK ${ik.name} bends ${ref}; edit or delete it first` });
}
